export default function LogoMark({ className = "w-9 h-9", showText = true }) {
  return (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="50" cy="50" r="46" stroke="currentColor" strokeWidth="4" />
      <path
        d="M50 10 L50 90 M10 50 L90 50 M22 22 L78 78 M22 78 L78 22"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeDasharray="4 3"
      />
      <circle cx="50" cy="50" r="21" fill="#E85D9E" />
      {showText && (
        <text x="50" y="55" fontFamily="Georgia, serif" fontWeight="bold" fontSize="13" fill="#FFFFFF" textAnchor="middle">
          E·N
        </text>
      )}
    </svg>
  );
}
